var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#55ACE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 18.625C37.375 19 36.375 19.25 35.375 19.375C36.375 18.75 37.25 17.75 37.625 16.625C36.625 17.25 35.625 17.625 34.375 17.875C33.5 16.875 32.125 16.25 30.75 16.25C28 16.25 25.75 18.5 25.75 21.25C25.75 21.625 25.75 22 25.875 22.375C21.75 22.125 18 20.125 15.5 17.125C15.125 17.875 14.875 18.75 14.875 19.625C14.875 21.375 15.75 22.875 17.125 23.75C16.25 23.75 15.5 23.5 14.875 23.125C14.875 25.5 16.625 27.625 18.875 28C18.5 28.125 18 28.125 17.5 28.125C17.125 28.125 16.875 28.125 16.5 28C17.125 30 19 31.5 21.25 31.5C19.5 32.875 17.375 33.625 15 33.625C14.625 33.625 14.25 33.625 13.75 33.5C16 34.875 18.625 35.75 21.5 35.75C30.75 35.75 35.75 28.125 35.75 21.5V20.875C36.75 20.5 37.625 19.625 38.25 18.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.958dde5f1db82e9916e68bb7f0eb739e.svg";
export { ForwardRef as ReactComponent };